export const CLASS_NAMES = {
  container: 'flex flex-row justify-between relative',
  title: 'text-style-h-em text-neutral-600 mb-1',
};

export const TITLE = 'Deposit';
